'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

export default function RecaptchaProvider({ children }: Props) {
    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

    if (!siteKey) {
        console.warn('reCAPTCHA site key not configured');
        return <>{children}</>;
    }

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={siteKey}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'body',
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
}
